// 联系人状态

module.exports = {
    ONLINE: 1,
    OFFLINE: 0
};
